import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { ACURA_SITE_NAME } from '../constants';
var StepIdentifyingComponent;
(function (StepIdentifyingComponent) {
    StepIdentifyingComponent["CONFIGURE"] = "ConfigureBap";
    StepIdentifyingComponent["SUMMARY"] = "BapSummaryCard";
})(StepIdentifyingComponent || (StepIdentifyingComponent = {}));
/**
 * This hook returns the current BAP step from Sitecore Context
 * The preferred solution would be to return a value from sitecore context to the component
 * indicating the current page where needed // Todo: refactor to this implementation
 * @returns {object} current BAP step
 */
const useGetCurrentBapPage = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { sitecoreContext } = useSitecoreContext();
    const appName = (_a = sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.site) === null || _a === void 0 ? void 0 : _a.name;
    const placeholderName = appName === ACURA_SITE_NAME ? 'acura-main' : 'main';
    const componentsRecord = {};
    (_g = (_f = (_e = (_d = (_c = (_b = sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.route) === null || _b === void 0 ? void 0 : _b.placeholders) === null || _c === void 0 ? void 0 : _c[placeholderName]) === null || _d === void 0 ? void 0 : _d.find(({ componentName }) => componentName === 'SidebarLayout')) === null || _e === void 0 ? void 0 : _e.placeholders) === null || _f === void 0 ? void 0 : _f['sidebar-column-right']) === null || _g === void 0 ? void 0 : _g.forEach(({ componentName }) => {
        componentsRecord[componentName] = true;
    });
    return {
        isSummaryPage: (_h = componentsRecord[StepIdentifyingComponent.SUMMARY]) !== null && _h !== void 0 ? _h : false,
        isConfigurePage: (_j = componentsRecord[StepIdentifyingComponent.CONFIGURE]) !== null && _j !== void 0 ? _j : false,
    };
};
export default useGetCurrentBapPage;
